import { OriginType } from "inbounds/createShipment/CreateShipmentTypes";
import { createSelector } from "reselect";
import { selectCreateShipmentForm } from "./selectCreateShipmentForm";

export const selectIsDomesticOrigin = createSelector(
  selectCreateShipmentForm,
  (createShipment) => createShipment.originType === OriginType.DOMESTIC
);
